module.exports = __webpack_public_path__ + "img/img_services_bg.c9976ec0.png";